import { Box } from "@mantine/core";
import { AppRoute } from "app";
import { useAtomValue } from "jotai";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "theme";

import PhotoGrid from "components/PhotoGrid";
import Text from "components/Text";

import { sessionIdAtom } from "atoms/sessionId";
import { mileagePhotoAtom } from "atoms/vehicleCondition/mileage";
import { formattedVehicleConditionAtom } from "atoms/vehicleCondition/questions";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useEventTracking } from "hooks/useEventTracking";
import { replaceSessionInAppRoute } from "utils/routeHelper";

import Flex from "../../../components/Flex";
import { EditButton } from "../EditButton";
import { useStyles } from "../styles";

export const VehicleConditionSection = () => {
  const { classes } = useStyles();
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const vehicleCondition = useAtomValue(formattedVehicleConditionAtom);
  const mileagePhoto = useAtomValue(mileagePhotoAtom);
  const navigate = useNavigate();
  const sessionId = useAtomValue(sessionIdAtom);

  const onEdit = () => {
    trackEvent({
      name: "Claim Summary - edit",
      properties: {
        pageName: "Vehicle condition",
      },
    });

    navigate(replaceSessionInAppRoute(AppRoute.VehicleCondition, sessionId), { state: "FROM_SUMMARY" });
  };

  return (
    <>
      <Flex as="section" direction="row" justify="space-between" mb={16}>
        <Text as="h2" sizeVariant="lg" weight={500}>
          {t("vehicle_condition.header")}
        </Text>
        <EditButton onClick={onEdit} />
      </Flex>
      <Box component="section" className={classes.vehicleConditionGrid}>
        {vehicleCondition.map(({ label: translationKey, value }) => (
          <Fragment key={translationKey}>
            <Text sizeVariant="md" style={{ color: colors.grey[70] }}>
              {t(translationKey)}
            </Text>
            <Text className={classes.answers} sizeVariant="md">
              {value}
            </Text>
          </Fragment>
        ))}
        {mileagePhoto.length > 0 && (
          <>
            <Text sizeVariant="md" style={{ color: colors.grey[70] }}>
              {t("vehicle_condition.mileage.photo")}
            </Text>
            <PhotoGrid images={mileagePhoto} className={classes.mileagePhoto} />
          </>
        )}
      </Box>
    </>
  );
};
